import { IconCheck } from '@/components/icons';
import { UiIcon } from '@/components/ui/UiIcon';
import type { FormChoiceDto } from '../../form.types';
import {
    TILE_CHECK_CLASS,
    TILE_CLASS,
    TILE_CONTROL_CLASS,
    TILE_DESCRIPTION_CLASS,
    TILE_ICON_CLASS,
    TILE_LABEL_CLASS,
} from './field.styles';

interface FormChoiceTileProps {
    choice: FormChoiceDto;
    type: 'checkbox' | 'radio';
    name?: string;
    required?: boolean;
    defaultChecked?: boolean;
}

/** One choice of a checkbox or radio group as a tile: icon, label, an optional
 *  second line and a check mark once selected. The native input lies invisibly
 *  over the whole tile, so click, focus ring and validation bubble sit on it. */
export function FormChoiceTile({ choice, type, name, required, defaultChecked }: FormChoiceTileProps) {
    return (
        <label className={TILE_CLASS}>
            <input
                type={type}
                name={name}
                value={choice.value}
                required={required}
                defaultChecked={defaultChecked}
                className={TILE_CONTROL_CLASS}
            />
            {choice.icon ? (
                <span className={TILE_ICON_CLASS} aria-hidden="true">
                    <UiIcon name={choice.icon} size={19} />
                </span>
            ) : null}
            <span className={TILE_LABEL_CLASS}>
                {choice.label}
                {choice.description ? (
                    <>
                        {/* Keeps label and second line apart in the accessible name. */}
                        <span className="sr-only">, </span>
                        <span className={TILE_DESCRIPTION_CLASS}>{choice.description}</span>
                    </>
                ) : null}
            </span>
            <span className={TILE_CHECK_CLASS} aria-hidden="true">
                <IconCheck width={13} height={13} />
            </span>
        </label>
    );
}
